import {
  Flex,
  Container,
  Heading,
  Stack,
  Text,
  Button,
} from "@chakra-ui/react";

import { Link } from "react-router-dom";


export default function Header() {
  return (
    <Container maxW={"5xl"}>
      <Stack
        textAlign={"center"}
        align={"center"}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 20, md: 28 }}
      >
        <Heading
          fontWeight={600}
          fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
          lineHeight={"110%"}
        >
          Hello there! I'm{" "}
          <Text as={"span"} color={"purple.400"}>
            $takisdo_
          </Text>
        </Heading>
        <Text color={"gray.500"} maxW={"3xl"}>
          I'm a developer from Earth
        </Text>
        <Stack spacing={6} direction={"row"}>
          <Link to="/contact">
          <Button
            rounded={"full"}
            px={6}
            colorScheme={"purple"}
            bg={"purple.400"}
            _hover={{ bg: "purple.500" }}
          >
            Contact me &#61;&gt;
          </Button>
          </Link>
        </Stack>
        <Flex w={"full"}></Flex>
      </Stack>
    </Container>
  );
}
